import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { AuthApiService } from '../api';
import { Enable2FAData } from '../models';

@Injectable()
export class AuthApiServiceMock extends AuthApiService {
  override enable2fa() {
    const mockResponse: Enable2FAData = {
      qrCode: 'mock-qr-code',
      manualSetupUri: 'mock-manual-setup-uri',
      recoveryCodes: ['mock-recovery-code-1', 'mock-recovery-code-2'],
    };
    return of(mockResponse);
  }

  override verifyCode() {
    return of(void 0);
  }

  override resetCode() {
    return of(void 0);
  }

  override remove2fa() {
    return of(void 0);
  }

  override logout(): Observable<void> {
    return super.logout();
  }
}
